._NetworkSection_5wxyi_1 {
  padding-top: 0 !important;
}
._NetworkSection_5wxyi_1 ._networkIcon_5wxyi_4 > path, ._NetworkSection_5wxyi_1 ._networkIcon_5wxyi_4 > circle, ._NetworkSection_5wxyi_1 ._networkIcon_5wxyi_4 > rect, ._NetworkSection_5wxyi_1 ._networkIcon_5wxyi_4 > polygon {
  fill: unset !important;
}